module.exports = __webpack_public_path__ + "img/mourning-2.72603193.webp";